
import {
  HOSTING_ELEMENT_CHANGED, INIT_HOSTING_ELEMENT
} from '../constants/actionTypes';

export function initHostingElement(elementProps) {
  return {
    type: INIT_HOSTING_ELEMENT,
    payload: elementProps,
  };
}
export default function hostingElementChanged(newElementProperties) {
  return {
    type: HOSTING_ELEMENT_CHANGED,
    payload: newElementProperties,
  };
}

